import {PageStandard} from "../utils/PageStandard";
import {Fragment, useEffect, useState} from "react";
import {Traduzione, TraduzioniModel} from "../utils/Model";
import {Button, CircularProgress, Input, Stack, Table, Typography} from "@mui/joy";
import {getTraduzioni, uploadTraduzioni} from "../utils/ViewModel";


export function Traduzioni() {

    const [traduzioni, setTraduzioni] = useState<TraduzioniModel | null>(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getTraduzioni().then(data => {
            setTraduzioni({
                categorieTitles: data?.categorieTitles ?? {},
                serviziTitles: {},
                booking: data?.booking ?? {},
                notes: data?.notes ?? {},
                openingHours: data?.openingHours ?? {},
            })
            //console.log(data?.booking)
        })
    }, []);

    return (
        <PageStandard title="Traduzioni" sidebarVisible={true} headerEnd={
            <Stack direction="row" spacing={5}>
                { /*
                <Button onClick={() => {
                    setTraduzioni({
                        categorieTitles: {},
                        serviziTitles: {},
                        booking: newData,
                        notes: {},
                        openingHours: {},
                    })
                }}>
                    Change data
                </Button>
                */ }
                <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
                    <CircularProgress determinate value={getPercentageComplete()} />
                    <Typography><b>{getPercentageComplete()} %</b> completato</Typography>
                </Stack>
                <Button onClick={async () => {
                    if(window.confirm("Sicuro?")) {
                        if (!traduzioni) return
                        setLoading(true)
                        const res = await uploadTraduzioni(traduzioni)
                        if (!res) alert("Errore")
                        else alert(res.message)
                        setLoading(false)
                    }
                        }}
                        disabled={!traduzioni || loading}
                >
                    {
                        loading ?
                            <CircularProgress color="neutral" />
                            :
                            "Salva traduzioni"
                    }
                </Button>
            </Stack>
        }>
            <Table>
                <thead>
                    <tr>
                        <th>🇮🇹 Italiano</th>
                        <th>🇬🇧 Inglese</th>
                        <th>🇫🇷 Francese</th>
                        <th>🇸🇦 Arabo</th>
                        <th>🇪🇸 Spagnolo</th>
                    </tr>
                </thead>
                <tbody>
                {
                    traduzioni !== null &&
                    (Object.keys(traduzioni) as (keyof TraduzioniModel)[]).map(categoria => {
                        return (
                            <Fragment key={categoria}>
                                <tr>
                                    <td colSpan={5} style={{ fontWeight: "bold" }}>
                                        {categoria}
                                    </td>
                                </tr>
                                {Object.entries(traduzioni[categoria]).map(([key, trad]) => (
                                    <tr key={key}>
                                        <td>{key}</td>
                                        {(["en", "fr", "ar", "es"] as (keyof Traduzione)[]).map(lang => (
                                            <td key={lang}>
                                                <Input
                                                    type="text"
                                                    size="sm"
                                                    value={trad[lang] ?? ""}
                                                    onChange={e => handleChange(categoria, key, lang, e.target.value)}
                                                    error={!trad[lang]}
                                                    disabled={loading}
                                                />
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </Fragment>
                        );
                    })
                }
                </tbody>
            </Table>
        </PageStandard>
    )

    function handleChange(
        categoria: keyof TraduzioniModel,
        key: string,
        lang: keyof Traduzione,
        value: string
    ) {
        if (!traduzioni) return;

        setTraduzioni(prev => {
            if (!prev) return prev; // safety

            // Clona profondamente solo la parte da modificare per mantenere immutabilità
            const newTraduzioni = { ...prev };
            const newCategoria = { ...newTraduzioni[categoria] };
            const newTrad = { ...newCategoria[key] };

            newTrad[lang] = value.trim() === "" ? null : value; // se vuoto metto null

            newCategoria[key] = newTrad;
            newTraduzioni[categoria] = newCategoria;

            return newTraduzioni;
        });
    }

    function getPercentageComplete(): number {
        if (traduzioni === null) return 0

        let totalStrings = 0;
        let translatedStrings = 0;

        (Object.keys(traduzioni) as (keyof TraduzioniModel)[]).forEach(categoria => {
            const entries = Object.values(traduzioni[categoria]);
            totalStrings += entries.length;

            entries.forEach(trad => {
                // Conta come tradotto se almeno una lingua è non null e non vuota
                if (trad.en || trad.fr || trad.ar || trad.es) {
                    translatedStrings++;
                }
            });
        });

        if (totalStrings === 0) return 0;

        return Math.round((translatedStrings / totalStrings) * 100);
    }
}